import React from "react";
import { Grid, Button } from "@mui/material";
import { useForm } from "react-hook-form";
import ReusableModal from "../../Components/Modal/WSModal";
import WSTextField, {
  CurrencyType,
  TextType
} from "../../Components/TextBox/WSTextBox";

interface ModalProps {
  id?: string;
  open: boolean;
  onClose: () => void;
  onCreate: (data: any) => void;
}

const RateCardModal: React.FC<ModalProps> = ({
  id,
  open,
  onClose,
  onCreate
}) => {
  const { control, handleSubmit,reset } = useForm();

  const onSubmit = async (data: any) => {
    onCreate(data);
    reset();
  };

  const footer = (
    <Button
      variant="contained"
      onClick={handleSubmit(onSubmit)}
      sx={{
        backgroundColor: "#FF6B2C",
        "&:hover": { backgroundColor: "#e65c1d" }
      }}
    >
      Create
    </Button>
  );

  return (
    <>
      <ReusableModal
        open={open}
        onClose={onClose}
        title="New Client"
        footer={footer}
        width="sm"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSTextField
              id="name"
              label="Rate Card Name"
              name="name"
              control={control}
              sx={{
                marginBottom: 1,
                backgroundColor: "rgba(0,0,0,.05)",
                boxShadow: "none",
                border: 0,
                color: "#444",
                fontSize: 16,
                transition: "width 0.25s"
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <WSTextField
              id="role"
              label="Role"
              name="role"
              control={control}
              rules={{ required: "role is required" }}
              sx={{
                marginBottom: 1,
                backgroundColor: "rgba(0,0,0,.05)",
                boxShadow: "none",
                border: 0,
                color: "#444",
                fontSize: 16,
                transition: "width 0.25s"
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <WSTextField
              id="rate"
              label="Actual Rate"
              name="actualRate"
              control={control}
              rules={{ required: "actual rate is required" }}
              type={TextType.Currency}
              currency={CurrencyType.Rupee}
              sx={{
                marginBottom: 1,
                backgroundColor: "rgba(0,0,0,.05)",
                boxShadow: "none",
                border: 0,
                color: "#444",
                fontSize: 16,
                transition: "width 0.25s"
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <WSTextField
              id="rate"
              label="Customer Rate"
              name="customerRate"
              control={control}
              rules={{ required: false }}
              type={TextType.Currency}
              currency={CurrencyType.Rupee}
              sx={{
                marginBottom: 1,
                backgroundColor: "rgba(0,0,0,.05)",
                boxShadow: "none",
                border: 0,
                color: "#444",
                fontSize: 16,
                transition: "width 0.25s"
              }}
            />
          </Grid>
        </Grid>
      </ReusableModal>
    </>
  );
};

export default RateCardModal;
